import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { toolDefinitionService } from '@/services';
import { buScopeKey, buScopeParams } from '@/lib/business-unit-scope';

/**
 * The actions the workflow editor offers under `/`.
 *
 * Brand-scoped, like every other list in the app: the request carries the selected brand and
 * the key carries it too. The key matters as much as the request here — the selection change
 * does not clear queries, so a key without the brand would keep serving the first brand's
 * actions after switching to the second.
 */
const toolDefinitionsQueryAtom = atomWithQuery((get) => ({
  queryKey: ['tool-definitions', buScopeKey(get)],
  queryFn: () => toolDefinitionService.getAll(buScopeParams(get)),
  staleTime: 5 * 60 * 1000,
}));

export function useToolDefinitions() {
  const atom = useMemo(() => toolDefinitionsQueryAtom, []);
  const [query] = useAtom(atom);
  return query;
}
